module.exports = __webpack_public_path__ + "static/media/space-rocket-flying.5a3b9c38.svg";